window.onload = function(){
 var linkmsg=document.getElementById("linkmsg");
 linkmsg.style.visibility="visible";
 linkmsg.innerHTML="カラーを選択してください";
}
// PetitComサイズ画像変更
function showimg1(){
document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/ldsofa_size-armless.png?v=1643520649";
document.getElementById("message").innerHTML = "<p>奥行65cm又は奥行75cm、幅65～190cmまで1cm単位でオーダー可能です。<br>(奥行75cmは幅75cm～オーダー可能です)</p>";
}
function showimg2(){
document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/ldsofa_size-left.png?v=1643520722";
document.getElementById("message").innerHTML = "<p>奥行65cm又は奥行75cm、幅65～190cmまで1cm単位でオーダー可能です。<br>(奥行75cmは幅75cm～オーダー可能です)</p>";
}
function showimg3(){
document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/ldsofa_size-right.png?v=1643520722";
document.getElementById("message").innerHTML = "<p>奥行65cm又は奥行75cm、幅65～190cmまで1cm単位でオーダー可能です。<br>(奥行75cmは幅75cm～オーダー可能です)</p>";
}
// PetitComサイズオーダー
function checkBtn(){
 var idCloth = document.getElementsByName( "cava_tab" ) ;
 var strCloth = "";
 var i=0;
 for ( strCloth="", i=idCloth.length; i--; ) {
  if ( idCloth[i].checked ) {
   strCloth = idCloth[i].id.slice(4);
   break ;
  }
 }
 var idColor = document.getElementsByName( "colortype" ) ;
 var strColor=""
 for (strColor="", i=idColor.length; i--; ) {
  if ( idColor[i].checked ) {
   strColor = idColor[i].id ;
   break ;
  }
 }
//option test
  var idOption = document.getElementsByName( "option" ) ;
 var strOption=""
 for (strOption="", i=idOption.length; i--; ) {
  if ( idOption[i].checked ) {
   strOption = idOption[i].id ;
   break ;
  }
 }
 var linkmsg=document.getElementById("linkmsg");
 var strErrmsg="";
 if(strCloth.slice(0,2)!=strColor.slice(0,2)){
  linkmsg.style.visibility="visible";
  strErrmsg="カラーを選択してください";
  document.getElementById("price").value=""
  document.frm_detail.checkbtn.disabled =true;
 }else if(strCloth.slice(0,2)=="mo"&&strColor.slice(0,2)=="mo"){
  if(strCloth.slice(0,3)!=strColor.slice(0,3)){
   linkmsg.style.visibility="visible";
   strErrmsg="カラーを選択してください";
   document.getElementById("price").value=""
   document.frm_detail.checkbtn.disabled =true;
     }else{
   linkmsg.style.visibility="hidden";
   linkmsg.innerHTML="";
   document.getElementById("price").value=""
   document.frm_detail.checkbtn.disabled =false;
     }
 }else{
  linkmsg.style.visibility="hidden";
  linkmsg.innerHTML="";
  document.getElementById("price").value=""
  document.frm_detail.checkbtn.disabled =false;
 }
 if(strErrmsg!=""){
 linkmsg.innerHTML=strErrmsg;
    }
}
function checkOption(){
 document.getElementById("price").value=""
 cart_price.innerHTML =""+" 円";
 cart_haba.innerHTML="";
 //cart_depth.innerHTML="";
 cart_height.innerHTML="";
 cart_cloth.innerHTML="";
 cart_color.innerHTML="";
 cart_option.innerHTML="";
}
const strLink1="<a href=\"https://arneinteior.myshopify.com/products/"
const strLink2="\" target=\"_blank\">→こちらのページよりお買い求めください。</a>"

function setGoods(url,haba,depth,height,price,cloth,option){
this.url=url;this.haba=haba;this.depth=depth;this.height=height;this.price=price;this.cloth=cloth;this.option=option;}
function searchURL(strHaba,strDepth,strHeight,strCloth,strOption){
var strErr;
//var intDepth=document.getElementById("depth").value
var intHaba=document.getElementById("haba").value
var intHeight=document.getElementById("height").value

//幅チェック
if (intHeight == 65 && intHaba < 65){
 strErr="幅65cm未満は";
}else if (intHaba > 190){
  strErr="幅190cm以上は";
}
if (intHeight == 75 && intHaba < 75){
  strErr="奥行75cmは幅75cm未満での";
}else if (intHaba > 190){
  strErr="幅190cm以上は";
}
if(strErr){document.getElementById("price").value="";
return strErr+"オーダー不可です。";}
  

//幅サイズ成形
switch(strHaba.length){
 case 2:
  if(strHaba.slice(0,1)=="9" && strHaba.slice(-1)!="0"){
   strHaba ="100";
  }else if(strHaba.slice(-1) !="0"){
   strHaba=parseInt(strHaba.slice(0,1))+1+"0";
  }else{
   
  }
  break;
 case 3:
  if(strHaba.slice(-1)=="0"){
   
  }else{
  strHaba=strHaba.slice(0,1)+parseInt(parseInt(strHaba.slice(1,2))+1)+"0";
  }
  break;
}
  

//生地判定
if(strCloth=="ns7" || strCloth=="sofia" || strCloth=="modern" || strCloth=="meisai"){priceRow = 0;}
else if(strCloth=="resort"){priceRow = 1;}
else if(strCloth=="leather" || strCloth=="denim" || strCloth=="holiday"){priceRow = 2;}
else if(strCloth=="moq"){priceRow = 3;}
else if(strCloth=="michael"){priceRow = 4;}
else{alert("生地を選択してください");return false;}

if(strDepth !== "armless"){priceRow=priceRow+5;}

if(intHeight == 65){
switch(intHaba != ""){
  case intHaba <= 65: priceColumn = 0;break;
  case intHaba <= 70: priceColumn = 1;break;
  case intHaba <= 80: priceColumn = 2;break;
  case intHaba <= 90: priceColumn = 3;break;
  case intHaba <= 100: priceColumn = 4;break;
  case intHaba <= 110: priceColumn = 5;break;
  case intHaba <= 120: priceColumn = 6;break;
  case intHaba <= 130: priceColumn = 7;break;
  case intHaba <= 140: priceColumn = 8;break;
  case intHaba <= 150: priceColumn = 9;break;
  case intHaba <= 160: priceColumn = 10;break;
  case intHaba <= 170: priceColumn = 11;break;
  case intHaba <= 180: priceColumn = 12;break;
  case intHaba <= 190: priceColumn = 13;break;
}}
else if(intHeight == 75){
switch(intHaba != ""){
  case intHaba <= 75: priceColumn = 14;break;
  case intHaba <= 80: priceColumn = 15;break;
  case intHaba <= 90: priceColumn = 16;break;
  case intHaba <= 100: priceColumn = 17;break;
  case intHaba <= 110: priceColumn = 18;break;
  case intHaba <= 120: priceColumn = 19;break;
  case intHaba <= 130: priceColumn = 20;break;
  case intHaba <= 140: priceColumn = 21;break;
  case intHaba <= 150: priceColumn = 22;break;
  case intHaba <= 160: priceColumn = 23;break;
  case intHaba <= 170: priceColumn = 24;break;
  case intHaba <= 180: priceColumn = 25;break;
  case intHaba <= 190: priceColumn = 26;break;
}}

    var arr = csvToArray("https://cdn.shopify.com/s/files/1/0549/1834/8887/files/ldsofa_price.csv?v=1649734222");
    var sellPrice = arr[priceRow][priceColumn];
    return sellPrice;

  function csvToArray(filename) {

    var srt = new XMLHttpRequest();
    srt.open("GET", filename, false);
    try {
      srt.send(null);
    } catch (err) {
      console.log(err)
    }
    var csvArr = [];
    var lines = srt.responseText.split("\n");
    for (var i = 0; i < lines.length; ++i) {
      var cells = lines[i].split(",");
      if (cells.length != 1) {
        csvArr.push(cells);
      }
    }
    return csvArr;
  }
}


/*リストから商品URLを取得*/
function checkURL(strHaba,strDepth,strHeight,strCloth,strOption){
  for(var i in goods){
if(goods[i].haba==strHaba && goods[i].depth==strDepth && goods[i].height==strHeight && goods[i].cloth==strCloth && goods[i].option==strOption){
return goods[i].url;}}
return false;
}
// 数値チェック
function isNumber(numVal){
  var pattern =/^([1-9]\d*|0)$/;
  return pattern.test(numVal);
}
/*価格算出ボタン押下時*/
function jump(){
 document.getElementById("price").value =""+" 円";
 cart_price.innerHTML =""+" 円";
 cart_productform.innerHTML="";
 cart_haba.innerHTML="";
 cart_height.innerHTML="";
 cart_cloth.innerHTML="";
 cart_color.innerHTML="";
 cart_option.innerHTML="";
 
var linkmsg=document.getElementById("linkmsg");
linkmsg.innerHTML="";
linkmsg.style.visibility="hidden";
var ErrMsg=document.getElementById("linkmsg");
ErrMsg.innerHTML="";
document.getElementById("price").value=""

var strDepth=""
var idProductForm=document.getElementsByName( "productform" ) ;
var strHaba=document.getElementById("haba").value;
var strHeight=document.getElementById("height").value;
var idCloth = document.getElementsByName( "cava_tab" ) ;
var idColor = document.getElementsByName( "colortype" ) ;
var idOption = document.getElementsByName( "option" ) ;
var strCloth = "";
var strColor = "";
var strOption = "";
var i=0;
var a=0;
var b=0;
var c=0;
for ( strDepth="", b=idProductForm.length; b--; ) {
 if ( idProductForm[b].checked ) {
  strDepth = idProductForm[b].id ;
  var valueProductForm = idProductForm[b].value ;
  break ;
 }
}
for ( strCloth="", i=idCloth.length; i--; ) {
 if ( idCloth[i].checked ) {
  strCloth = idCloth[i].id.slice(4);
  var valueCloth = idCloth[i].value ;
  break ;
 }
}
for ( strColor="", a=idColor.length; a--; ) {
 if ( idColor[a].checked ) {
  strColor = idColor[a].id ;
  var valueColor = idColor[a].value ;
  break ;
 }
}
for ( strOption="", c=idOption.length; c--; ) {
 if ( idOption[c].checked ) {
  strOption = idOption[c].id ;
  var valueOption = idOption[c].value ;
  break ;
 }
}
if (isNumber(strHaba)==false){
alert("幅は『1以上の整数(小数点不可/半角文字）』をご入力ください。");
return false;
}
document.getElementById("choice1").value=strHaba+"cm"
document.getElementById("choice2").value=strHeight+"cm"
document.getElementById("choice3").value=valueProductForm
document.getElementById("choice4").value=valueCloth+"生地"
document.getElementById("choice5").value=valueColor
document.getElementById("choice6").value=valueOption+"脚"


//商品ページの有無チェック
var comcode=checkURL(strHaba,strDepth,strHeight,strCloth,strOption);
if (!comcode=="" && strColor!=="moq_sgy"){
var target=document.getElementById("linkmsg");
linkmsg.style.visibility="visible";
target.innerHTML="ご希望サイズは既製品がございます。<br>"+strLink1+comcode+"/"+strLink2;
return false;
}
if (!comcode=="" && strColor=="moq_sgy"){
var target=document.getElementById("linkmsg");
linkmsg.style.visibility="visible";
target.innerHTML="モケット生地シルバーグレーは別注色のため金額が異なります。";
}
var url=searchURL(strHaba,strDepth,strHeight,strCloth,strOption);

if(!url){
alert("幅を入力してください");
return false;
}
var intUnit
if (isNaN(url)==false){
 intUnit=parseInt(url)/1000;
 document.getElementById("price").value =parseInt(url).toLocaleString()+" 円";
 cart_price.innerHTML =parseInt(url).toLocaleString()+" 円";
 cart_haba.innerHTML=strHaba;
 cart_productform.innerHTML=valueProductForm;
 cart_height.innerHTML=strHeight;
 cart_cloth.innerHTML=valueCloth;
 cart_color.innerHTML=valueColor;
 cart_option.innerHTML=valueOption;
}
else if(isNaN(url)==true) {
linkmsg.style.visibility="visible";
 ErrMsg.innerHTML=url;
 intUnit=""
}
document.getElementById("units").value=intUnit;
document.getElementById("choice7").value="見積もり金額："+url;
return false;
}
function checkText() {
 var choice1=document.frm.choice1.value;
 var choice2=document.frm.choice2.value;  
 var choice3=document.frm.choice3.value;  
    var text = document.frm.inventory_id.value;
    var price = document.frm_detail.price.value;
    if(choice1=="" || choice2=="") {
        alert("ご希望のサイズを正しく入力後、価格算出ボタンを押してください。");
        return false;
        }           

    if(price=="") {
        alert("価格が算出されていません。既製品がある場合、「この条件で金額算出」ボタン下の該当商品ページよりお買い求めください。");
        return false;
        }       
     return true;
}
goods = new Object();
goods[0] =new setGoods("0000a51167","65","left","65","38000","sofia","20dbr");
goods[1] =new setGoods("0000a51607","120","right","65","56000","sofia","20dbr");
goods[2] =new setGoods("0000a51662","170","right","65","71000","sofia","20dbr");
goods[3] =new setGoods("0000a51717","190","right","65","77000","sofia","20dbr");
goods[4] =new setGoods("0000a51442","120","left","65","56000","sofia","20dbr");
goods[5] =new setGoods("0000a51497","170","left","65","71000","sofia","20dbr");
goods[6] =new setGoods("0000a51552","190","left","65","77000","sofia","20dbr");
goods[7] =new setGoods("0000a51222","65","armless","65","33000","sofia","20dbr");
goods[8] =new setGoods("0000a51277","120","armless","65","51000","sofia","20dbr");
goods[9] =new setGoods("0000a51332","170","armless","65","66000","sofia","20dbr");
goods[10] =new setGoods("0000a51387","190","armless","65","72000","sofia","20dbr");
goods[11] =new setGoods("0000a51179","65","left","65","38000","modern","20dbr");
goods[12] =new setGoods("0000a51619","120","right","65","56000","modern","20dbr");
goods[13] =new setGoods("0000a51674","170","right","65","71000","modern","20dbr");
goods[14] =new setGoods("0000a51729","190","right","65","77000","modern","20dbr");
goods[15] =new setGoods("0000a51454","120","left","65","56000","modern","20dbr");
goods[16] =new setGoods("0000a51509","170","left","65","71000","modern","20dbr");
goods[17] =new setGoods("0000a51564","190","left","65","77000","modern","20dbr");
goods[18] =new setGoods("0000a51234","65","armless","65","33000","modern","20dbr");
goods[19] =new setGoods("0000a51289","120","armless","65","51000","modern","20dbr");
goods[20] =new setGoods("0000a51344","170","armless","65","66000","modern","20dbr");
goods[21] =new setGoods("0000a51399","190","armless","65","72000","modern","20dbr");
goods[22] =new setGoods("0000a51202","65","left","65","43000","moq","20dbr");
goods[23] =new setGoods("0000a51642","120","right","65","67000","moq","20dbr");
goods[24] =new setGoods("0000a51697","170","right","65","87000","moq","20dbr");
goods[25] =new setGoods("0000a51752","190","right","65","95000","moq","20dbr");
goods[26] =new setGoods("0000a51477","120","left","65","67000","moq","20dbr");
goods[27] =new setGoods("0000a51532","170","left","65","87000","moq","20dbr");
goods[28] =new setGoods("0000a51587","190","left","65","95000","moq","20dbr");
goods[29] =new setGoods("0000a51257","65","armless","65","40000","moq","20dbr");
goods[30] =new setGoods("0000a51312","120","armless","65","64000","moq","20dbr");
goods[31] =new setGoods("0000a51367","170","armless","65","84000","moq","20dbr");
goods[32] =new setGoods("0000a51422","190","armless","65","92000","moq","20dbr");
goods[33] =new setGoods("0000a51212","65","left","65","50000","michael","20dbr");
goods[34] =new setGoods("0000a51652","120","right","65","74000","michael","20dbr");
goods[35] =new setGoods("0000a51707","170","right","65","94000","michael","20dbr");
goods[36] =new setGoods("0000a51762","190","right","65","102000","michael","20dbr");
goods[37] =new setGoods("0000a51487","120","left","65","74000","michael","20dbr");
goods[38] =new setGoods("0000a51542","170","left","65","94000","michael","20dbr");
goods[39] =new setGoods("0000a51597","190","left","65","102000","michael","20dbr");
goods[40] =new setGoods("0000a51267","65","armless","65","44000","michael","20dbr");
goods[41] =new setGoods("0000a51322","120","armless","65","68000","michael","20dbr");
goods[42] =new setGoods("0000a51377","170","armless","65","88000","michael","20dbr");
goods[43] =new setGoods("0000a51432","190","armless","65","96000","michael","20dbr");
goods[44] =new setGoods("0000a51197","65","left","65","43000","leather","20dbr");
goods[45] =new setGoods("0000a51637","120","right","65","67000","leather","20dbr");
goods[46] =new setGoods("0000a51692","170","right","65","87000","leather","20dbr");
goods[47] =new setGoods("0000a51747","190","right","65","95000","leather","20dbr");
goods[48] =new setGoods("0000a51472","120","left","65","67000","leather","20dbr");
goods[49] =new setGoods("0000a51527","170","left","65","87000","leather","20dbr");
goods[50] =new setGoods("0000a51582","190","left","65","95000","leather","20dbr");
goods[51] =new setGoods("0000a51252","65","armless","65","40000","leather","20dbr");
goods[52] =new setGoods("0000a51307","120","armless","65","64000","leather","20dbr");
goods[53] =new setGoods("0000a51362","170","armless","65","84000","leather","20dbr");
goods[54] =new setGoods("0000a51417","190","armless","65","92000","leather","20dbr");
goods[55] =new setGoods("0000a51192","65","left","65","43000","denim","20dbr");
goods[56] =new setGoods("0000a51632","120","right","65","67000","denim","20dbr");
goods[57] =new setGoods("0000a51687","170","right","65","87000","denim","20dbr");
goods[58] =new setGoods("0000a51742","190","right","65","95000","denim","20dbr");
goods[59] =new setGoods("0000a51467","120","left","65","67000","denim","20dbr");
goods[60] =new setGoods("0000a51522","170","left","65","87000","denim","20dbr");
goods[61] =new setGoods("0000a51577","190","left","65","95000","denim","20dbr");
goods[62] =new setGoods("0000a51247","65","armless","65","40000","denim","20dbr");
goods[63] =new setGoods("0000a51302","120","armless","65","64000","denim","20dbr");
goods[64] =new setGoods("0000a51357","170","armless","65","84000","denim","20dbr");
goods[65] =new setGoods("0000a51412","190","armless","65","92000","denim","20dbr");
goods[66] =new setGoods("0000a51187","65","left","65","43000","holiday","20dbr");
goods[67] =new setGoods("0000a51627","120","right","65","67000","holiday","20dbr");
goods[68] =new setGoods("0000a51682","170","right","65","87000","holiday","20dbr");
goods[69] =new setGoods("0000a51737","190","right","65","95000","holiday","20dbr");
goods[70] =new setGoods("0000a51462","120","left","65","67000","holiday","20dbr");
goods[71] =new setGoods("0000a51517","170","left","65","87000","holiday","20dbr");
goods[72] =new setGoods("0000a51572","190","left","65","95000","holiday","20dbr");
goods[73] =new setGoods("0000a51242","65","armless","65","40000","holiday","20dbr");
goods[74] =new setGoods("0000a51297","120","armless","65","64000","holiday","20dbr");
goods[75] =new setGoods("0000a51352","170","armless","65","84000","holiday","20dbr");
goods[76] =new setGoods("0000a51407","190","armless","65","92000","holiday","20dbr");
goods[77] =new setGoods("0000a51182","65","left","65","43000","resort","20dbr");
goods[78] =new setGoods("0000a51622","120","right","65","61000","resort","20dbr");
goods[79] =new setGoods("0000a51677","170","right","65","76000","resort","20dbr");
goods[80] =new setGoods("0000a51732","190","right","65","82000","resort","20dbr");
goods[81] =new setGoods("0000a51457","120","left","65","61000","resort","20dbr");
goods[82] =new setGoods("0000a51512","170","left","65","76000","resort","20dbr");
goods[83] =new setGoods("0000a51567","190","left","65","82000","resort","20dbr");
goods[84] =new setGoods("0000a51237","65","armless","65","38000","resort","20dbr");
goods[85] =new setGoods("0000a51292","120","armless","65","56000","resort","20dbr");
goods[86] =new setGoods("0000a51347","170","armless","65","71000","resort","20dbr");
goods[87] =new setGoods("0000a51402","190","armless","65","77000","resort","20dbr");
goods[88] =new setGoods("0000a51772","65","left","65","38000","sofia","20na");
goods[89] =new setGoods("0000a52212","120","right","65","56000","sofia","20na");
goods[90] =new setGoods("0000a52267","170","right","65","71000","sofia","20na");
goods[91] =new setGoods("0000a52322","190","right","65","77000","sofia","20na");
goods[92] =new setGoods("0000a52047","120","left","65","56000","sofia","20na");
goods[93] =new setGoods("0000a52102","170","left","65","71000","sofia","20na");
goods[94] =new setGoods("0000a52157","190","left","65","77000","sofia","20na");
goods[95] =new setGoods("0000a51827","65","armless","65","33000","sofia","20na");
goods[96] =new setGoods("0000a51882","120","armless","65","51000","sofia","20na");
goods[97] =new setGoods("0000a51937","170","armless","65","66000","sofia","20na");
goods[98] =new setGoods("0000a51992","190","armless","65","72000","sofia","20na");
goods[99] =new setGoods("0000a51784","65","left","65","38000","modern","20na");
goods[100] =new setGoods("0000a52224","120","right","65","56000","modern","20na");
goods[101] =new setGoods("0000a52279","170","right","65","71000","modern","20na");
goods[102] =new setGoods("0000a52334","190","right","65","77000","modern","20na");
goods[103] =new setGoods("0000a52059","120","left","65","56000","modern","20na");
goods[104] =new setGoods("0000a52114","170","left","65","71000","modern","20na");
goods[105] =new setGoods("0000a52169","190","left","65","77000","modern","20na");
goods[106] =new setGoods("0000a51839","65","armless","65","33000","modern","20na");
goods[107] =new setGoods("0000a51894","120","armless","65","51000","modern","20na");
goods[108] =new setGoods("0000a51949","170","armless","65","66000","modern","20na");
goods[109] =new setGoods("0000a52004","190","armless","65","72000","modern","20na");
goods[110] =new setGoods("0000a51807","65","left","65","43000","moq","20na");
goods[111] =new setGoods("0000a52247","120","right","65","67000","moq","20na");
goods[112] =new setGoods("0000a52302","170","right","65","87000","moq","20na");
goods[113] =new setGoods("0000a52357","190","right","65","95000","moq","20na");
goods[114] =new setGoods("0000a52082","120","left","65","67000","moq","20na");
goods[115] =new setGoods("0000a52137","170","left","65","87000","moq","20na");
goods[116] =new setGoods("0000a52192","190","left","65","95000","moq","20na");
goods[117] =new setGoods("0000a51862","65","armless","65","40000","moq","20na");
goods[118] =new setGoods("0000a51917","120","armless","65","64000","moq","20na");
goods[119] =new setGoods("0000a51972","170","armless","65","84000","moq","20na");
goods[120] =new setGoods("0000a52027","190","armless","65","92000","moq","20na");
goods[121] =new setGoods("0000a51817","65","left","65","50000","michael","20na");
goods[122] =new setGoods("0000a52257","120","right","65","74000","michael","20na");
goods[123] =new setGoods("0000a52312","170","right","65","94000","michael","20na");
goods[124] =new setGoods("0000a52367","190","right","65","102000","michael","20na");
goods[125] =new setGoods("0000a52092","120","left","65","74000","michael","20na");
goods[126] =new setGoods("0000a52147","170","left","65","94000","michael","20na");
goods[127] =new setGoods("0000a52202","190","left","65","102000","michael","20na");
goods[128] =new setGoods("0000a51872","65","armless","65","44000","michael","20na");
goods[129] =new setGoods("0000a51927","120","armless","65","68000","michael","20na");
goods[130] =new setGoods("0000a51982","170","armless","65","88000","michael","20na");
goods[131] =new setGoods("0000a52037","190","armless","65","96000","michael","20na");
goods[132] =new setGoods("0000a51802","65","left","65","43000","leather","20na");
goods[133] =new setGoods("0000a52242","120","right","65","67000","leather","20na");
goods[134] =new setGoods("0000a52297","170","right","65","87000","leather","20na");
goods[135] =new setGoods("0000a52352","190","right","65","95000","leather","20na");
goods[136] =new setGoods("0000a52077","120","left","65","67000","leather","20na");
goods[137] =new setGoods("0000a52132","170","left","65","87000","leather","20na");
goods[138] =new setGoods("0000a52187","190","left","65","95000","leather","20na");
goods[139] =new setGoods("0000a51857","65","armless","65","40000","leather","20na");
goods[140] =new setGoods("0000a51912","120","armless","65","64000","leather","20na");
goods[141] =new setGoods("0000a51967","170","armless","65","84000","leather","20na");
goods[142] =new setGoods("0000a52022","190","armless","65","92000","leather","20na");
goods[143] =new setGoods("0000a51797","65","left","65","43000","denim","20na");
goods[144] =new setGoods("0000a52237","120","right","65","67000","denim","20na");
goods[145] =new setGoods("0000a52292","170","right","65","87000","denim","20na");
goods[146] =new setGoods("0000a52347","190","right","65","95000","denim","20na");
goods[147] =new setGoods("0000a52072","120","left","65","67000","denim","20na");
goods[148] =new setGoods("0000a52127","170","left","65","87000","denim","20na");
goods[149] =new setGoods("0000a52182","190","left","65","95000","denim","20na");
goods[150] =new setGoods("0000a51852","65","armless","65","40000","denim","20na");
goods[151] =new setGoods("0000a51907","120","armless","65","64000","denim","20na");
goods[152] =new setGoods("0000a51962","170","armless","65","84000","denim","20na");
goods[153] =new setGoods("0000a52017","190","armless","65","92000","denim","20na");
goods[154] =new setGoods("0000a51792","65","left","65","43000","holiday","20na");
goods[155] =new setGoods("0000a52232","120","right","65","67000","holiday","20na");
goods[156] =new setGoods("0000a52287","170","right","65","87000","holiday","20na");
goods[157] =new setGoods("0000a52342","190","right","65","95000","holiday","20na");
goods[158] =new setGoods("0000a52067","120","left","65","67000","holiday","20na");
goods[159] =new setGoods("0000a52122","170","left","65","87000","holiday","20na");
goods[160] =new setGoods("0000a52177","190","left","65","95000","holiday","20na");
goods[161] =new setGoods("0000a51847","65","armless","65","40000","holiday","20na");
goods[162] =new setGoods("0000a51902","120","armless","65","64000","holiday","20na");
goods[163] =new setGoods("0000a51957","170","armless","65","84000","holiday","20na");
goods[164] =new setGoods("0000a52012","190","armless","65","92000","holiday","20na");
goods[165] =new setGoods("0000a51787","65","left","65","43000","resort","20na");
goods[166] =new setGoods("0000a52227","120","right","65","61000","resort","20na");
goods[167] =new setGoods("0000a52282","170","right","65","76000","resort","20na");
goods[168] =new setGoods("0000a52337","190","right","65","82000","resort","20na");
goods[169] =new setGoods("0000a52062","120","left","65","61000","resort","20na");
goods[170] =new setGoods("0000a52117","170","left","65","76000","resort","20na");
goods[171] =new setGoods("0000a52172","190","left","65","82000","resort","20na");
goods[172] =new setGoods("0000a51842","65","armless","65","38000","resort","20na");
goods[173] =new setGoods("0000a51897","120","armless","65","56000","resort","20na");
goods[174] =new setGoods("0000a51952","170","armless","65","71000","resort","20na");
goods[175] =new setGoods("0000a52007","190","armless","65","77000","resort","20na");
goods[176] =new setGoods("0000a51167","65","right","65","38000","sofia","20dbr");
goods[177] =new setGoods("0000a51179","65","right","65","38000","modern","20dbr");
goods[178] =new setGoods("0000a51202","65","right","65","43000","moq","20dbr");
goods[179] =new setGoods("0000a51212","65","right","65","50000","michael","20dbr");
goods[180] =new setGoods("0000a51197","65","right","65","43000","leather","20dbr");
goods[181] =new setGoods("0000a51192","65","right","65","43000","denim","20dbr");
goods[182] =new setGoods("0000a51187","65","right","65","43000","holiday","20dbr");
goods[183] =new setGoods("0000a51182","65","right","65","43000","resort","20dbr");
goods[184] =new setGoods("0000a51772","65","right","65","38000","sofia","20na");
goods[185] =new setGoods("0000a51784","65","right","65","38000","modern","20na");
goods[186] =new setGoods("0000a51807","65","right","65","43000","moq","20na");
goods[187] =new setGoods("0000a51817","65","right","65","50000","michael","20na");
goods[188] =new setGoods("0000a51802","65","right","65","43000","leather","20na");
goods[189] =new setGoods("0000a51797","65","right","65","43000","denim","20na");
goods[190] =new setGoods("0000a51792","65","right","65","43000","holiday","20na");
goods[191] =new setGoods("0000a51787","65","right","65","43000","resort","20na");
